import { render, staticRenderFns } from "./ModalIAPost.vue?vue&type=template&id=ac45284c&scoped=true&"
import script from "./ModalIAPost.vue?vue&type=script&lang=js&"
export * from "./ModalIAPost.vue?vue&type=script&lang=js&"
import style0 from "./ModalIAPost.vue?vue&type=style&index=0&id=ac45284c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45284c",
  null
  
)

export default component.exports